import gql from 'graphql-tag'

export const GET_LINKED_ACCOUNTS = gql`
  query linkedAccounts {
    linkedAccounts {
      userId
      email
      hierarchy{
        id
        type
        name
      }
      scopes
    }
  }
`

export const GET_MY_PROFILE = gql`
  query getMyProfileNewModel {
    profileNewModel {
      id
      managedBy
      userId
      email
      firstName
      lastName
      scopes
      hierarchy {
        id
        type
      }
      linkedAccounts {
        userId
        email
        hierarchy {
          id
          type
          name
        }
        scopes
      }
      children {
        institutionType
        institutionId
        institutionName
        hierarchyType
        hierarchyId
        hierarchyName
        gradeLevel
        schoolYear
        schoolType
        childUid
        status
        community
        postalCode
        institutionGradeLevel
      }
      academicGroupMemberships {
        groupName
        groupId
        hierarchyName
        hierarchyId
      }
    }
  }
`
export const LOGIN_STATUS = gql`
  query {
    loginStatus {
      loggedIn
      redirectTo
    }
  }
`



// WEBPACK FOOTER //
// ./src/shared/api/http/graphql/accounts.graphql.js